import React, { useEffect, useState } from "react";
import { Client } from "@stomp/stompjs";
import { useSelector, useDispatch } from "react-redux";
import { CHANEL_NOTIFIKASI } from "./chanelWS";
import { userDataLocalStorage } from "../../functions/base64Function";
import { URL_WS } from "../../init/url";
import { SetWebSocketChanel } from "./action";
import { CloseWatingRoom } from "../../../moduls/WaitingRoomModul/actions/waitingRoomActions";
import { GetUsersWaiting } from "../../../moduls/WaitingRoomModul/actions/usersWaitingRoomActions";
import {
  SESSION_ANSWER_UPDATED,
  SESSION_STARTED,
  SESSION_ROOM_UPDATED,
  SESSION_ENDED,
} from "./constant";
import { GetListAnswerAssessee } from "../../../moduls/SessionMethodVideoModul/actions/answerAssesseeActions";
import { CloseSessionRoom } from "../../../moduls/SessionMethodVideoModul/actions/sessionMethodActions";

export default function InitWebSocket() {
  const [intTest, setIntTest] = useState(0);
  const { token, session } = userDataLocalStorage();

  const [listChanelSub, setListChanelSub] = useState([]);
  const [listChanelReqSub, setListChanelReqSub] = useState([]);
  const [conWs, setConWs] = useState(false);
  const chanelStore = useSelector((state) => state.getWebSocketChanel);
  const dispatch = useDispatch();
  const [client, setClient] = useState(
    new Client({
      brokerURL: URL_WS,
      connectHeaders: {
        auth: `${token}`,
      },
      debug: function (str) {
        console.log("ws debug", str);
      },
      // reconnectDelay: 5000,
      // heartbeatIncoming: 4000,
      // heartbeatOutgoing: 4000,
    })
  );

  useEffect(() => {
    client.onConnect = function (frame) {
      // Do something, all subscribes must be done is this callback
      // This is needed because this will be executed after a (re)connect
      console.log("ws connected ", frame);
      dispatch(SetWebSocketChanel(CHANEL_NOTIFIKASI(session)));
      setConWs(true);
    };
    client.onWebSocketClose = function (frame) {
      console.log("ws close connected ", frame);
      setConWs(false);
      setIntTest(1);
    };
    client.onStompError = function (frame) {
      setConWs(false);
      // Will be invoked in case of error encountered at Broker
      // Bad login/passcode typically will cause an error
      // Complaint brokers will set `message` header with a brief message. Body may contain details.
      // Compliant brokers will terminate the connection after any error
      console.log("ws Broker reported error: " + frame.headers["message"]);
      console.log("ws Additional details: " + frame.body);
    };
    client.activate();
  }, []);

  const reset = async () => {
    console.log("ws listChanel before: ", listChanelSub);
    setListChanelReqSub([].concat(listChanelSub));
    setListChanelSub([]);
    console.log("ws listChanel after: ", listChanelReqSub, listChanelSub);
    setIntTest(0);
  };

  useEffect(() => {
    if (chanelStore.data.chanel != undefined) {
      let chanelSubBool = listChanelSub?.includes(chanelStore.data?.chanel);
      let chanelReqSubBool = listChanelReqSub?.includes(
        chanelStore.data?.chanel
      );
      if (chanelSubBool == false && chanelReqSubBool == false) {
        setListChanelReqSub(...listChanelReqSub, [chanelStore.data.chanel]);
      }
    }
  }, [chanelStore]);

  useEffect(() => {
    if (intTest == 1) {
      reset();
    }
    if (conWs == true && intTest == 0) {
      console.log("ws listChanelReqSub", listChanelReqSub);
      let arrSub = [];
      listChanelReqSub?.map((val) => {
        if (!listChanelSub.includes(val)) {
          arrSub.push(val);
          console.log("ws listChanelReqSub", val, client, conWs);
          var subscription = client.subscribe(
            CHANEL_NOTIFIKASI(session),
            (message) => {
              callbackChanel(CHANEL_NOTIFIKASI(session), message);
            }
          );
          setListChanelReqSub(listChanelReqSub.filter((item) => item !== item));
        }
      });
      setListChanelSub(...listChanelSub, arrSub);
    }
  }, [conWs, listChanelReqSub]);

  // Chanel Management
  const callbackChanel = (chanel, message) => {
    let mesJson = JSON.parse(message.body);
    console.log("ws message callbackChanel manta", message);
    console.log("ws message callbackChanel", mesJson);
    // console.log("ws messag type status", mesJson.status);
    // ws messag type status SESSION_STARTED
    // console.log("ws messag type type", mesJson?.type);
    // console.log("ws messag Channel", chanel);

    switch (chanel) {
      case CHANEL_NOTIFIKASI(session):
        // console.log(mesJson.status);
        switch (mesJson.status) {
          case SESSION_STARTED:
            dispatch(CloseWatingRoom());
            break;
          case SESSION_ROOM_UPDATED:
            dispatch(GetUsersWaiting());
            break;
          case SESSION_ANSWER_UPDATED:
            dispatch(GetListAnswerAssessee());
            break;
          case SESSION_ENDED:
            dispatch(CloseSessionRoom());
            break;

          default:
            break;
        }
        break;
      default:
        break;
    }

    if (message.body) {
      console.log(
        "ws from " + chanel + " got message with body " + message.body
      );
    } else {
      console.log("ws from " + chanel + " got empty message");
    }
  };

  return <></>;
}
